import { IconButton, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  getConnectionQualityIcon,
  RECONNECTING_SIGNAL_LEVELS
} from '../helpers/connectionQuality/ConnectionQualityHelper';
import type { ConnectionQualityState, SignalLevel } from '../types/connectionQuality';

const RECONNECTING_STEP_MS = 350;

interface ConnectionQualityIconProps {
  state: ConnectionQualityState;
}

const ConnectionQualityIcon: React.FC<ConnectionQualityIconProps> = ({ state }) => {
  const isReconnecting = state.quality === 'reconnecting';
  const [reconnectingLevel, setReconnectingLevel] = useState<SignalLevel>(1);

  useEffect(() => {
    if (!isReconnecting) {
      setReconnectingLevel(1);
      return;
    }

    const intervalId = setInterval(() => {
      setReconnectingLevel((currentLevel) => {
        const currentIndex = RECONNECTING_SIGNAL_LEVELS.indexOf(currentLevel);
        const nextIndex = (currentIndex + 1) % RECONNECTING_SIGNAL_LEVELS.length;
        return RECONNECTING_SIGNAL_LEVELS[nextIndex];
      });
    }, RECONNECTING_STEP_MS);

    return () => clearInterval(intervalId);
  }, [isReconnecting]);

  const Icon = getConnectionQualityIcon(
    state.quality,
    state.signalLevel,
    isReconnecting ? reconnectingLevel : undefined
  );

  return (
    <Tooltip title={state.label} arrow>
      <IconButton
        size="small"
        aria-label={state.label}
        disableRipple
        className="chatyme-connection-quality-icon-button"
        sx={{
          cursor: 'default',
          padding: '4px',
          '&:hover': { backgroundColor: 'transparent' }
        }}
      >
        <Icon
          sx={{
            color: state.signalColor,
            fontSize: 22
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default ConnectionQualityIcon;
